import MyImgList from './imgList.vue';

MyImgList.install = function(Vue){
  Vue.component('MyImgList', MyImgList);
};

export default MyImgList;